// O atributo disabled do botão "Salvar" só é aplicado no próximo render do React — um duplo
// clique (ou Enter repetido) muito rápido pode disparar handleCreateTask duas vezes em paralelo
// antes do disable "pegar", subindo o mesmo anexo duas vezes e inserindo a solicitação com dados
// inconsistentes entre as duas execuções concorrentes. Essa função centraliza a decisão da trava
// pra poder ser testada isoladamente, sem precisar renderizar o componente.
export function podeIniciarSubmit(jaEmAndamento: boolean): boolean {
    return !jaEmAndamento;
}
